import { useCallback } from 'react';
import { isQueryFinishedLoading } from '@/utils/isQueryFinishedLoading';
import { useAllClientListQuery } from './useAllClientListQuery';

export const useClientHelpers = () => {
  const query = useAllClientListQuery();

  const getClientName = useCallback(
    (id: string) => {
      if (isQueryFinishedLoading(query) === false) {
        throw new Error('Client list is not loaded yet');
      }
      const found = query.data?.find((client) => client.id === id);

      if (!found) throw new Error(`Client with id ${id} not found in client list`);
      return found.clientName;
    },
    [query]
  );

  return { getClientName, clientsQuery: query };
};
